import React, { useState } from "react";
import { api } from "@/lib/ledgerApi";
import { Loader2, FileDown, BookLock } from "lucide-react";

const download = async (path, fileName, title) => {
  const res = await api.get(path, { responseType: "blob" });
  const file = new File([res.data], fileName, { type: "application/pdf" });
  let shared = false;
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title });
      shared = true;
    } catch (e) {
      shared = e && e.name === "AbortError";
    }
  }
  if (!shared) {
    const url = URL.createObjectURL(file);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
  }
};

export const MenuPdfButton = ({ onAuthError }) => {
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      await download("/admin/menu-pdf", "Menu.pdf", "house of appetite — menu");
    } catch (e) {
      if (onAuthError) onAuthError(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid="ledger-menu-pdf-button"
      onClick={start}
      disabled={busy}
      className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-8 rounded-full border border-[rgba(179,145,74,0.45)] text-[var(--hoa-cream-50)] font-label text-[11px] tracking-[0.2em] uppercase hover:bg-[rgba(240,233,216,0.06)] transition-colors disabled:opacity-60"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileDown className="w-4 h-4" strokeWidth={1.8} />}
      Menu PDF
    </button>
  );
};

export const RecipeBookButton = ({ onAuthError }) => {
  const [busy, setBusy] = useState(false);

  const start = async () => {
    setBusy(true);
    try {
      await download("/admin/recipe-book-pdf", "HOA-Recipe-Book.pdf", "house of appetite — recipe book");
    } catch (e) {
      if (onAuthError) onAuthError(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      data-testid="ledger-recipe-book-button"
      onClick={start}
      disabled={busy}
      className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-8 rounded-full border border-[rgba(179,145,74,0.45)] text-[var(--hoa-cream-50)] font-label text-[11px] tracking-[0.2em] uppercase hover:bg-[rgba(240,233,216,0.06)] transition-colors disabled:opacity-60"
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <BookLock className="w-4 h-4" strokeWidth={1.8} />}
      Recipe Book
    </button>
  );
};
